<template>
  <v-alert
    v-if="hasErrors"
    type="error"
  >
    <p
      v-for="error in errorMessages"
      :key="error"
    >
      {{ error }}
    </p>
  </v-alert>
</template>

<script>
export default {
  name: 'MfaStepErrorDisplay',
  props: {
    errors: { type: Array, required: true }
  },
  computed: {
    hasErrors() {
      return this.errors.length > 0
    },
    errorMessages() {
      return this.errors.map((error) => error())
    }
  }
}
</script>
